import { render, staticRenderFns } from "./InvitationExpired.vue?vue&type=template&id=4cd6081d"
import script from "./InvitationExpired.vue?vue&type=script&lang=js"
export * from "./InvitationExpired.vue?vue&type=script&lang=js"
import style0 from "./InvitationExpired.vue?vue&type=style&index=0&id=4cd6081d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports